<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="800px">
    <div style="height: 400px; margin: 10px 80px 10px 80px;">
      <el-form label-position="right" label-width="90px" :model="customer" :rules="rules" ref="customer" :key="isNew">
        <div class="label">客户信息</div>
        <div style="display: flex">
          <div style="width: 0; flex-grow: 1;">
            <input-form-item label="客户姓名" prop="name"></input-form-item>
            <date-form-item label="生日" prop="birthday"></date-form-item>
            <InputFormItem label="QQ" prop="qq"></InputFormItem>
          </div>
          <div style="width: 0; flex-grow: 1;">
            <remote-form-item v-if="!shopId" label="门店" prop="shopId" class-name="Shop"></remote-form-item>
            <InputFormItem label="手机号" prop="cellphone"></InputFormItem>
            <remote-form-item label="性别" prop="gender" class-name="Gender"></remote-form-item>
          </div>
        </div>
        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>

        <div class="label">车辆信息</div>
        <div style="display: flex">
          <div style="width: 0; flex-grow: 1;">
            <input-form-item label="车牌号" prop="carNo"></input-form-item>
            <brand-model-form-item label="品牌/车系" prop="brandModel"></brand-model-form-item>
          </div>
          <div style="width: 0; flex-grow: 1;">
            <color-form-item label="车身色" prop="color"></color-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import { shareDataMixin } from '@/views/mixins/ShareData'
  import InputFormItem from '@/components/form/InputFormItem'
  import DateFormItem from '@/components/form/DateFormItem'
  import RemoteFormItem from '@/components/form/RemoteFormItem'
  import TextareaFormItem from '@/components/form/TextareaFormItem'
  import BrandModelFormItem from '@/components/form/BrandModelFormItem'
  import ColorFormItem from '@/components/form/ColorFormItem'
  import { isMobile } from '@/utils/validate'

  export default {
    name: 'EditCustomerDialog',
    mixins: [shareDataMixin],
    components: {
      ColorFormItem,
      BrandModelFormItem,
      TextareaFormItem,
      RemoteFormItem,
      DateFormItem,
      InputFormItem
    },
    props: {
      customer: {
        type: Object,
        required: true
      },
      readOnly: Boolean
    },
    data () {
      return {
        rules: {
          name: [
            {
              required: true,
              message: '请输入客户姓名',
              trigger: 'blur'
            }
          ],
          cellphone: [
            {
              required: true,
              trigger: 'blur',
              validator (rule, value, callback) {
                if (!isMobile(value)) {
                  callback(new Error('请输入正确手机号码'))
                } else {
                  callback()
                }
              }
            }
          ],
          gender: [
            {
              required: true,
              message: '请选择性别',
              trigger: 'blur'
            }
          ],
          shopId: [
            {
              required: true,
              message: '请选择门店',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      closed () {
        if (!this.readOnly) {
          this.$refs.customer.resetFields()
        }
      },
      add () {
        this.$refs.customer.validate(valid => {
          if (!valid) return

          this.$store.dispatch('customer/add', this.$_.cloneDeep(this.customer)).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      save () {
        this.$refs.customer.validate(valid => {
          if (!valid) return

          this.$store.dispatch('customer/updateOne', this.$_.cloneDeep(this.customer)).then(() => {
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isNew () {
        return !this.customer.id
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增客户'
        return this.readOnly ? '查看客户' : '编辑客户'
      },
      shopId () {
        return this.$store.state.user.shopId
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label {
    color: black;
    font-weight: bold;
    margin-bottom: 10px;
  }
</style>
